import { render, staticRenderFns } from "./ObjectCopyPhoto.vue?vue&type=template&id=c84e6eb6&scoped=true&"
import script from "./ObjectCopyPhoto.vue?vue&type=script&lang=js&"
export * from "./ObjectCopyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCopyPhoto.vue?vue&type=style&index=0&id=c84e6eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e6eb6",
  null
  
)

export default component.exports